import React, { useState, useEffect } from "react";
import { userProfile } from "../services/userService";


const UserProfile = () => {
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    
  });
  const [isEditing, setIsEditing] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get user data from localStorage or API
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    setUser(userData);
    setFormData({
      name: userData.name || "",
      email: userData.email || "",
      phone: userData.phone || "",
      
    });
    setLoading(false);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    const profilePayload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      
    };

    try {
      const response = await userProfile(profilePayload);

      console.log("Profile Update Response:", response);

      if (response?.success) {
        setUser(response.data);
        localStorage.setItem("user", JSON.stringify(response.data));
        setMessage("Profile updated successfully!");
        setIsEditing(false);
      } else {
        setMessage(response?.message || "Failed to update profile");
      }
    } catch (error) {
      console.error("Profile update error:", error);
      setMessage("Server error. Please try again.");
    } finally {
      setLoading(false);
      setTimeout(() => setMessage(""), 3000);
    }
  };

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-8 mx-auto">
          <div className="card">
            <div className="card-header">
              <h2 className="mb-0">User Profile</h2>
            </div>
            <div className="card-body">
              {message && (
                <div
                  className={`alert ${
                    message.includes("successfully")
                      ? "alert-success"
                      : "alert-danger"
                  }`}
                >
                  {message}
                </div>
              )}

              {isEditing ? (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="phone"
                      name="phone"
                       style={{ backgroundColor: "#1c1f24 !importent"  }}
                      readOnly
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                 

                  <div className="d-flex gap-2">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save Changes"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setIsEditing(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              ) : (
                <>
                  <div className="row mb-4">
                    <div className="col-md-4 fw-bold">Name:</div>
                    <div className="col-md-8">{user?.name}</div>
                  </div>

                  <div className="row mb-4">
                    <div className="col-md-4 fw-bold">Email:</div>
                    <div className="col-md-8">{user?.email}</div>
                  </div>

                  <div className="row mb-4">
                    <div className="col-md-4 fw-bold">Phone:</div>
                    <div className="col-md-8">
                      {user?.phone || "Not provided"}
                    </div>
                  </div>

                  

                  <button
                    className="btn btn-primary"
                    onClick={() => setIsEditing(true)}
                  >
                    Edit Profile
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
